import React from 'react'
import RightHandSide from '../../Common/Services/RightHandSide'
import AboutInnBanContent from '../../Common/InnerBanner/AboutInnBanContent';
import { AboutInnerBanner } from '../../Common/InnerBanner/AboutInnerBanner';
import HeadContent from '../BlogContent/HeadContent';
import HeadDesign from '../BlogContent/HeadDesign';
import Info from '../BlogContent/Info';
import List from '../BlogContent/List';
import InfoContent from '../BlogContent/InfoContent';
import ListContent from '../BlogContent/ListContent';
import TableFormat from '../BlogContent/TableFormat';
import RecentBlogsList from '../BlogContent/RecentBlogsList';

const Blog12 = () => {
    const {image, heading, pageName} = AboutInnBanContent.BlogDetails;
    const {bg, para, date, blogHeading} = HeadContent.blog_12;

    const {title, p} = InfoContent.Blog_12.one;
    const {title2, p2} = InfoContent.Blog_12.two;
    const {title3, p3} = InfoContent.Blog_12.three;
    const {title4, p4} = InfoContent.Blog_12.four;
    const {title5, p5} = InfoContent.Blog_12.five;
    const {title6, p6} = InfoContent.Blog_12.six;
    const {Ctitle, Cp} = InfoContent.Blog_12.conclusion;


    const {liss1} = ListContent.Blog_12.L1;
    const {liss2} = ListContent.Blog_12.L2;
    const {liss3} = ListContent.Blog_12.L3;
    const {liss4} = ListContent.Blog_12.L4;
    const {liss5} = ListContent.Blog_12.L5;
    const {liss6} = ListContent.Blog_12.L6;
    const {liss7} = ListContent.Blog_12.L7;
    const {liss8} = ListContent.Blog_12.L8;
    const {liss9} = ListContent.Blog_12.L9;

  return (
    <>
     <AboutInnerBanner image={image} heading={heading} pageName={pageName} />

     <div className="blog-area pt-100 pb-70">
    <div className="container">
        <div className="row">
            <div className="col-lg-8">
            <HeadDesign bg={bg} para={para} date={date} blogHeading={blogHeading} />
            <Info title={title} p={p} />
            <List liss={liss1} />

            <Info title={title2} p={p2} />
            <h4>Pros of Fresh Embryo Transfer:</h4>
            <List liss={liss2} />

            <h4>Cons of Fresh Embryo Transfer:</h4>
            <List liss={liss3} />

            <Info title={title3} p={p3} />
            <h4>Pros of Frozen Embryo Transfer:</h4>
            <List liss={liss4} />
            <h4>Cons of Frozen Embryo Transfer:</h4>
            <List liss={liss5} />

            <h4>Fresh vs Frozen Embryo Transfer: Key Differences</h4>
            <TableFormat/>

            <Info title={title4} p={p4} />
            <List liss={liss6} />

            <Info title={title5} p={p5} />
            <List liss={liss7} />
            
            <Info title={title6} p={p6} />
            <List liss={liss8} />
      
            <Info title={Ctitle} p={Cp} />
            <h4>Talk to your fertility specialist to:</h4>
            <List liss={liss9} />
            </div>
            <div className="col-lg-4">
                <RecentBlogsList/>
                <RightHandSide/>
            </div>
        </div>
    </div>
    </div>
    </>
  )
}

export default Blog12